import React, { Component } from 'react';
import { Table, Input, Button, Icon } from 'antd';
import { List, Card } from 'antd';
import { Row, Col, Divider } from 'antd';
import { Steps } from 'antd';
import { Checkbox } from 'antd';
const Step = Steps.Step;
const Search = Input.Search;


class SelectedSegmentsTable extends Component {
    constructor() {
        super();
        this.state = {
            segment: [],
            columnData: [],
            scrollY: 0
        }
        // this.scrollY = 0;
    }


    componentWillReceiveProps() {
        let aTempSegment = [];
        outterloop: for (var i = 0; i < this.props.schedulesBrief.length; i++) {
            if (this.props.schedulesBrief[i].selected) {
                for (var j = 0; j < this.props.schedules.length; j++) {
                    if (this.props.schedules[j].res_num === this.props.schedulesBrief[i].res_num) {
                        aTempSegment.push(this.props.schedules[j]);
                    } else if (aTempSegment != null && aTempSegment.length != 0) {
                        break outterloop;
                    }
                }
            }
        }
        if (aTempSegment === null || aTempSegment.length === 0 || this.arraysEqual(aTempSegment, this.state.segment)) {
            if(aTempSegment === null || aTempSegment.length === 0){
                this.setState({ segment: aTempSegment, scrollY: this.props.scrollY });
            }
            return;
        }
        if (aTempSegment != null && aTempSegment.length != 0) {
            if (document.getElementById("myRightBottomNav").hidden) {
                document.getElementById("myRightBottomNav").hidden = false;
            }
            // aTempSegment.push({});
        } else {
            if (!document.getElementById("myRightBottomNav").hidden) {
                document.getElementById("myRightBottomNav").hidden = true;
            }
        }
        this.setState({ segment: aTempSegment, scrollY: this.props.scrollY });
        this.initColumnData(aTempSegment);
    }

    componentDidMount(){
        let aMaxHeight = window.innerHeight - 405;
        let aProtentialHeight = this.state.segment.length * 138;
        if(aProtentialHeight >= aMaxHeight){
            // use aMaxHeight as scrollYHeight
            // this.setState({ scrollY: aMaxHeight })
            // this.scrollY = aMaxHeight;
            // this.props.updateRightBottomSideNavHeight(aMaxHeight);
        }else{
            // use aProtentialHeight as scrollYHeight
            // this.setState({ scrollY: aProtentialHeight })
            // this.scrollY = aProtentialHeight;
            // this.props.updateRightBottomSideNavHeight(aProtentialHeight);
        }
    }

    componentDidUpdate(){
        let aMaxHeight = window.innerHeight - 405;
        let aProtentialHeight = this.state.segment.length * 138;
        if(aProtentialHeight >= aMaxHeight){
            // use aMaxHeight as scrollYHeight
            // this.setState({ scrollY: aMaxHeight })
            // this.scrollY = aMaxHeight;
            // this.props.updateRightBottomSideNavHeight(aMaxHeight);
        }else{
            // use aProtentialHeight as scrollYHeight
            // this.setState({ scrollY: aProtentialHeight })
            // this.scrollY = aProtentialHeight;
            // this.props.updateRightBottomSideNavHeight(aProtentialHeight);
        }
    }

    arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length != b.length) return false;
        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }

    initColumnData(theSegment) {
        let aColumnData = [];
        if (typeof theSegment !== "undefined" && theSegment !== null && theSegment.length !== 0) {
            let aBodyStyle = { padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
            let aStatusStyle = { marginRight: 2, borderTopLeftRadius: 50, borderTopRightRadius: 50, borderBottomLeftRadius: 50, borderBottomRightRadius: 50, width: 26, height: 26, background: '#2ACD3F' };
            for (var i = 0; i < theSegment.length; i++) {
                if (theSegment[i].stop_type.toUpperCase() === 'PICKUP') {
                    aBodyStyle = { padding: 8, backgroundColor: "gold", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                } else {
                    aBodyStyle = { padding: 8, backgroundColor: "Ivory", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                }
                if (theSegment[i].client_name !== null && theSegment[i].res_num !== null && theSegment[i].client_name.toUpperCase() === theSegment[i].res_num.toUpperCase()) {
                    aBodyStyle = { padding: 8, backgroundColor: "#1890ff", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 };
                    aStatusStyle = {display: 'none', marginRight: 2, borderTopLeftRadius: 50, borderTopRightRadius: 50, borderBottomLeftRadius: 50, borderBottomRightRadius: 50, width: 26, height: 26, background: '#2ACD3F' };
                }else{
                    aStatusStyle = {display: 'none', marginRight: 2, borderTopLeftRadius: 50, borderTopRightRadius: 50, borderBottomLeftRadius: 50, borderBottomRightRadius: 50, width: 26, height: 26, background: '#2ACD3F' };
                }
                aColumnData.push({
                    key: (i + 1).toString(),
                    idx_in_trips: (i + 1).toString(),
                    segment_info:
                        <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
                            bordered={false} type="inner" >
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}><b>{this.convertMinutesToAmPm(theSegment[i].triptime)}</b></font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginLeft: 8 }}><b>{theSegment[i].client_name.toUpperCase()}</b></font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2, marginRight: 3 }}>{"ETA: " + this.convertMinutesToAmPm(theSegment[i].eta)}</font>
                                </Col>
                                <Col>
                                    <Divider type="vertical" style={{ backgroundColor: 'darkgrey' }} />
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginLeft: 3, marginRight: 3 }}>{"ETD: " + this.convertMinutesToAmPm(theSegment[i].eta)}</font>
                                </Col>
                                <Col>
                                    <Divider type="vertical" style={{ backgroundColor: 'darkgrey' }} />
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginLeft: 3 }}>{"ACT: " + this.convertMinutesToAmPm(theSegment[i].triptime)}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2, marginRight: 2 }}>{theSegment[i].address}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>{theSegment[i].citystate}</font>
                                </Col>
                                <Col>
                                    <div style={aStatusStyle}></div>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2, marginRight: 2 }}>Note: </font><font size="2" style={{ marginLeft: 2 }}>{theSegment[i].driver_notes}</font>
                                </Col>
                            </Row>
                        </Card>
                    /* segment_info:
                        <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={aBodyStyle}
                            bordered={false} type="inner" >
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}><b>{theSegment[i].client_name.toUpperCase()}</b></font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginRight: 26 }}>{this.convertMinutesToAmPm(theSegment[i].eta)}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>{theSegment[i].address}</font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginRight: 2 }}><b>{this.convertMinutesToAmPm(theSegment[i].triptime)}</b></font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>{theSegment[i].citystate}</font>
                                </Col>
                                <Col>
                                    <font size="2" style={{ marginRight: 26 }}>{this.convertMinutesToAmPm(theSegment[i].etd)}</font>
                                </Col>
                            </Row>
                            <Row type="flex" justify="start" align="middle">
                                <Col>
                                    <font size="2" style={{ marginLeft: 2 }}>Note: </font><font size="2" style={{ marginLeft: 2 }}>{theSegment[i].driver_notes}</font>
                                </Col>
                            </Row>
                        </Card> */
                });
            }
        }
        this.setState({ columnData: aColumnData });
    }

    onRowClick(theRow) {
        console.log(theRow);
        this.props.updateStopSelection(parseInt(theRow.idx_in_trips) - 1);
    }

    render() {
        const columns = [{
            title: '',
            dataIndex: 'segment_info',
            width: 330,
            render: (text, record) => record.segment_info,
        }];

        // rowSelection object indicates the need for row selection
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            })
        };
        return (
            <div>
                <Table columns={columns} dataSource={this.state.columnData} pagination={false} scroll={{ y: this.state.scrollY }} showHeader={false} size="small" style={{ backgroundColor: "rgba(255, 255, 255,0)" }}
                    onRow={(record) => {
                        return {
                            onClick: () => { this.onRowClick(record) }
                        };
                    }}
                />
                {/* <List style={{overflowY: "auto"}}
                    itemLayout="vertical"
                    dataSource={bTestData}
                    renderItem={item => (
                        <List.Item>
                            <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}
                                bordered={false} type="inner" >
                                <Row type="flex" justify="space-between" align="middle">
                                    <Col>
                                        <font size="2"><b>MOORE, UNIQUE</b></font><font size="2" style={{ marginLeft: 6 }}>(OUT)</font>
                                    </Col>
                                    <Col>
                                        <font size="2">MEDICAID-BOSTON</font>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="start" align="middle">
                                    <Col>
                                        <font size="1"><b>0900AM</b></font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="1"><b>66 ROCKLAND ST, ROXBURY</b></font>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="start" align="middle">
                                    <Col style={{ marginLeft: 40 }}>
                                        <Icon type="arrow-down" />
                                    </Col>
                                    <Col style={{ marginLeft: 6 }}>
                                        <font size="2">S118</font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="1"><b>ATLWL</b></font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="2" style={{ color: "green" }}><b>CONFIRMED</b></font>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="start" align="middle">
                                    <Col>
                                        <font size="1"><b>1200PM</b></font>
                                    </Col>
                                    <Col style={{ marginLeft: 8 }}>
                                        <font size="1"><b>780 AMERICAN LEGION HWY, BOSTON</b></font>
                                    </Col>
                                </Row>
                            </Card>
                        </List.Item>
                    )}
                /> */}
                {/* <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)", width: 330, padding: 0, overflowY: "auto" }} bodyStyle={{ padding: 6}}>
                    <Card style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}
                        bordered={false} type="inner" >
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <font size="2"><b>MOORE, UNIQUE</b></font><font size="2" style={{ marginLeft: 6 }}>(OUT)</font>
                            </Col>
                            <Col>
                                <font size="2">MEDICAID-BOSTON</font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>0900AM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>66 ROCKLAND ST, ROXBURY</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col style={{ marginLeft: 40 }}>
                                <Icon type="arrow-down" />
                            </Col>
                            <Col style={{ marginLeft: 6 }}>
                                <font size="2">S118</font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>ATLWL</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="2" style={{ color: "green" }}><b>CONFIRMED</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>1200PM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>780 AMERICAN LEGION HWY, BOSTON</b></font>
                            </Col>
                        </Row>
                    </Card>
                    <Card style={{ backgroundColor: "rgba(255, 255, 255,0)", paddingTop: 6 }} bodyStyle={{ padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}
                        bordered={false} type="inner" >
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <font size="2"><b>MOORE, UNIQUE</b></font><font size="2" style={{ marginLeft: 6 }}>(OUT)</font>
                            </Col>
                            <Col>
                                <font size="2">MEDICAID-BOSTON</font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>0900AM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>66 ROCKLAND ST, ROXBURY</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col style={{ marginLeft: 40 }}>
                                <Icon type="arrow-down" />
                            </Col>
                            <Col style={{ marginLeft: 6 }}>
                                <font size="2">S118</font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>ATLWL</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="2" style={{ color: "green" }}><b>CONFIRMED</b></font>
                            </Col>
                        </Row>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <font size="1"><b>1200PM</b></font>
                            </Col>
                            <Col style={{ marginLeft: 8 }}>
                                <font size="1"><b>780 AMERICAN LEGION HWY, BOSTON</b></font>
                            </Col>
                        </Row>
                    </Card>
                    {aTestData}
                </Card> */}
            </div>
        );
    }

    convertMinutesToAmPm(pMins) {
        let theMins = -1;
        if (pMins !== null && typeof pMins === "string" && pMins.length != 0) {
            theMins = parseInt(pMins);
        } else if (typeof pMins === "number") {
            theMins = pMins;
        }
        if (theMins < 0) {
            return "";
        }
        let aIsAm = true;
        if (theMins >= 12 * 60) {
            aIsAm = false;
        }
        let aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        if (aIsAm) {
            if (aIsAm === 0) {
                return "0000A";
            }
            aHr = Math.floor(theMins / 60);
            aMin = theMins % 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "A";
        } else {
            if (theMins === 12 * 60) {
                return "1200P";
            }
            aHr = Math.floor((theMins - 12 * 60) / 60);
            aMin = (theMins - 12 * 60) % 60;
            if (aHr < 10) {
                if (aHr === 0) {
                    aHrStr = "12";
                } else {
                    aHrStr = "0" + aHr.toString();
                }
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "P";
        }
    }
}

export default SelectedSegmentsTable;



// WEBPACK FOOTER //
// ./src/Componets/SelectedSegmentsTable.js